/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The QuestionnairesidQuestionnaireAnswersAttributes model module.
 * @module model/QuestionnairesidQuestionnaireAnswersAttributes
 * @version v0.3
 */
export default class QuestionnairesidQuestionnaireAnswersAttributes {
  /**
   * Constructs a new <code>QuestionnairesidQuestionnaireAnswersAttributes</code>.
   * @alias module:model/QuestionnairesidQuestionnaireAnswersAttributes
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>QuestionnairesidQuestionnaireAnswersAttributes</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/QuestionnairesidQuestionnaireAnswersAttributes} obj Optional instance to populate.
   * @return {module:model/QuestionnairesidQuestionnaireAnswersAttributes} The populated <code>QuestionnairesidQuestionnaireAnswersAttributes</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new QuestionnairesidQuestionnaireAnswersAttributes();
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('position'))
        obj.position = ApiClient.convertToType(data['position'], 'Number');
      if (data.hasOwnProperty('value'))
        obj.value = ApiClient.convertToType(data['value'], 'Number');
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'String');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('external_id'))
        obj.externalId = ApiClient.convertToType(data['external_id'], 'String');
      if (data.hasOwnProperty('external_source'))
        obj.externalSource = ApiClient.convertToType(data['external_source'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} title
 */
QuestionnairesidQuestionnaireAnswersAttributes.prototype.title = undefined;

/**
 * @member {Number} position
 */
QuestionnairesidQuestionnaireAnswersAttributes.prototype.position = undefined;

/**
 * @member {Number} value
 */
QuestionnairesidQuestionnaireAnswersAttributes.prototype.value = undefined;

/**
 * Allowed values for the <code>status</code> property.
 * @enum {String}
 * @readonly
 */
QuestionnairesidQuestionnaireAnswersAttributes.StatusEnum = {
  /**
   * value: "active"
   * @const
   */
  active: "active",

  /**
   * value: "archived"
   * @const
   */
  archived: "archived"
};
/**
 * @member {module:model/QuestionnairesidQuestionnaireAnswersAttributes.StatusEnum} status
 */
QuestionnairesidQuestionnaireAnswersAttributes.prototype.status = undefined;

/**
 * Specify the answers_attributes ID if you want to update the resource.
 * @member {String} id
 */
QuestionnairesidQuestionnaireAnswersAttributes.prototype.id = undefined;

/**
 * @member {String} externalId
 */
QuestionnairesidQuestionnaireAnswersAttributes.prototype.externalId = undefined;

/**
 * Allowed values for the <code>externalSource</code> property.
 * @enum {String}
 * @readonly
 */
QuestionnairesidQuestionnaireAnswersAttributes.ExternalSourceEnum = {
  /**
   * value: "FormSort"
   * @const
   */
  formSort: "FormSort",

  /**
   * value: "null"
   * @const
   */
  _null: "null"
};
/**
 * @member {module:model/QuestionnairesidQuestionnaireAnswersAttributes.ExternalSourceEnum} externalSource
 */
QuestionnairesidQuestionnaireAnswersAttributes.prototype.externalSource = undefined;

